var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "complete_content" },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { attrs: { id: "content" } },
          [
            _c("dd-sitemap", {
              attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
            }),
            _vm._v(" "),
            _vm.registType
              ? _c("section", [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dtl_btn2 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcSignIn")
                        }
                      }
                    },
                    [_vm._v("ログインページへ")]
                  )
                ])
              : _c("section", [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dtl_btn2 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("DcTop")
                        }
                      }
                    },
                    [_vm._v("トップページへ")]
                  )
                ])
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h1", [_vm._v("登録完了")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v("\n            ご登録ありがとうございました。"),
        _c("br"),
        _vm._v("\n            登録完了メールを自動送信しました。\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("h1", [_vm._v("申請完了")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n            ご登録ありがとうございました。申請完了メールを自動送信しました。"
        ),
        _c("br"),
        _vm._v(
          "\n            法人会員アカウントの発行可否は、所定の審査後にメールにてご連絡いたします。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98b05110", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b05110","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcRegistUserComplete.vue
// module id = null
// module chunks = 